import { lazy } from 'react';

export const PremiseList = lazy(() => import('./premise/PremiseList'));
export const PremiseDeepDive = lazy(() => import('./premise_deep_dive/PremiseDeepDive'));
export const AddPremise = lazy(() => import('./premise/AddPremise'));
export const UpdatePremise = lazy(() => import('./premise/UpdatePremise'));
export const ManagePremise = lazy(() => import('./manage_premise/ManagePremise'));
export const PremiseHierarchy = lazy(() => import('./manage_premise/PremiseHierarchy'));
export const AssignUnit = lazy(() => import('./assign_unit/AssignUnit'));
export const UnitDetails = lazy(() => import('./unit_details/UnitDetails'));
export const UpdateOwner = lazy(() => import('./assign_unit/UpdateOwner'));
export const UpdateTenant = lazy(() => import('./assign_unit/UpdateTenant'));
export const VacateUnit = lazy(() => import('./vacate_unit/VacateUnit'));
export const GateList = lazy(() => import('./gate/GateList'));
export const AddGate = lazy(() => import('./gate/AddGate'));
export const UpdateGate = lazy(() => import('./gate/UpdateGate'));
export const ParkingList = lazy(() => import('./parking/ParkingList'));
export const VehicleList = lazy(() => import('./vehicle/VehicleList'));
export const RuleList = lazy(() => import('./rules/RuleList'));
export const AddRule = lazy(() => import('./rules/AddRule'));
export const UpdateRule = lazy(() => import('./rules/UpdateRule'));
export const RuleDetails = lazy(() => import('./rules/RuleDetails'));
export const VendorList = lazy(() => import('./vendor/VendorList'));
export const AddVendor = lazy(() => import('./vendor/AddVendor'));
export const UpdateVendor = lazy(() => import('./vendor/UpdateVendor'));
export const Property = lazy(() => import('./property/Property'));
export const PremisesAndLogs = lazy(() => import('./premises_and_logs/PremisesAndLogs'));